import { NgFor, NgIf, CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { StockGeneralService } from '../../../../Services/Product_Creation/stock-general.service';
import { RouterLink } from '@angular/router';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PackagingService } from '../../../../Services/Product_Creation/packaging.service';
import { MetalService } from '../../../../Services/metal.service';
import { ProductService } from '../../../../Services/product.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-general-list',
  standalone: true,
  imports: [NgFor, RouterLink, FormsModule, NgIf, CommonModule],
  templateUrl: './general-list.component.html',
  styleUrls: ['./general-list.component.css'],
})
export class GeneralListComponent implements OnInit {
  stockGeneralList: any[] = [];
  paginatedStockList: any[] = [];
  generalData: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  fieldOptions: any;
  showDropdown: boolean = false;
  showselectDropdown: boolean = false;
  columns: any;
  visibleRowCount: any;
  globalSearchText: any;
  defaultFields: any[] = [];
  packagingDetail: any;
  metalDataList: any;
  stoneDataList: any;
  currentFirmId: any;
  firmSelectionSubscription: any;
  isReportPanel!: boolean;
  brandMap: { [key: number]: string } = {};

  constructor(
    private stockGeneralService: StockGeneralService,
    private snackBar: MatSnackBar,
    private eRef: ElementRef,
    private packagingService: PackagingService,
    private MetalService: MetalService,
    private firmSelectionService: FirmSelectionService,
    private productservice: ProductService
  ) { }

  router = inject(Router);

  ngOnInit(): void {
    this.firmSelectionSubscription = this.firmSelectionService.selectedFirmName$
      .subscribe((firm: any) => {
        this.currentFirmId = firm?.id;

        const genralist = localStorage.getItem('generallist');
        if (genralist) {
          this.fields = JSON.parse(genralist);
        }
        this.getStockGeneralList();
        this.getAllGeneral();
        this.getAssemblyBrands();
      });
  }

  // for list
  listTypes: string[] = ['General', 'categories', 'List 3'];
  selectedListType: string = '';
  searchField: string | null = null;
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  brandList: any[] = [];
  selectedBrandId: number | 'all' = 'all';

  searchValues: { [key: string]: string } = {
    barcode: '',
    unique_code_sku: '',
    brand_name: '',
    group: '',
    product_name: '',
    hsn_code: '',
  };

  updateVisibleRows() {
    this.paginatedStockList = this.stockGeneralList.slice(
      0,
      this.visibleRowCount
    );
  }

  getAssemblyBrands() {
    this.stockGeneralService.getBrandNames().subscribe(
      (res: any) => {
        this.brandList = res.data || [];

        // 🔹 Create ID → Name map
        this.brandMap = {};
        this.brandList.forEach((b: any) => {
          this.brandMap[b.id] = b.assembly_brand_name;
        });
      },
      () => {
        this.brandList = [];
        this.brandMap = {};
      }
    );
  }

  filterTable() {
    let filtered = [...this.stockGeneralList];

    /* 🔹 BRAND FILTER (ID based) */
    if (this.selectedBrandId !== 'all') {
      filtered = filtered.filter(
        item => Number(item.brand_name) === Number(this.selectedBrandId)
      );
    }

    /* 🔹 GLOBAL SEARCH */
    if (this.globalSearchText?.trim()) {
      const search = this.globalSearchText.toLowerCase();
      filtered = filtered.filter(item =>
        Object.values(item).some(val =>
          String(val ?? '').toLowerCase().includes(search)
        )
      );
    }

    /* 🔹 COLUMN SEARCH */
    filtered = filtered.filter(item =>
      Object.entries(this.searchValues).every(([key, value]) =>
        !value ||
        String(this.resolveValue(item, key))
          .toLowerCase()
          .includes(value.toLowerCase())
      )
    );

    /* 🔹 PAGINATION */
    this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
    this.currentPage = Math.min(this.currentPage, this.totalPages || 1);

    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.paginatedStockList = filtered.slice(start, end);
  }



  onHeaderClick(field: string): void {
    this.searchField = this.searchField === field ? null : field;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!this.eRef.nativeElement.contains(target)) {
      this.showDropdown = false;
    }
  }

  showRelatedList() {
    if (this.selectedListType === 'General') {
      this.router.navigate(['general-list']);
    } else if (this.selectedListType === 'categories') {
      this.router.navigate(['categories-list']);
    }
  }

  getStockGeneralList() {
    let params = new HttpParams().set('product_code_type','general')
      .set('firm_id', this.currentFirmId);

    if (this.router.url.includes('/report/general-list')) {
      params = params.set('type', 'Product');
      this.isReportPanel = true;
    }

    this.stockGeneralService.getProducts(params).subscribe((response: any) => {
      this.stockGeneralList = [...response.data].reverse();
      this.totalPages = Math.ceil(
        this.stockGeneralList.length / this.itemsPerPage
      );
      this.updatePaginatedList();
    });
  }


  deleteGeneralProduct(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This product will be permanently deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c19725',
      cancelButtonColor: '#c19725',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.stockGeneralService.deleteProduct(id).subscribe({
          next: (response: any) => {
            Swal.fire('Deleted!', 'The product has been deleted.', 'success');
            // Optionally refresh list
            this.getStockGeneralList();
          },
          error: () => {
            Swal.fire(
              'Error!',
              'Something went wrong while deleting.',
              'error'
            );
          },
        });
      }
    });
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedStockList = this.stockGeneralList.slice(start, end);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedList();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedList();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedList();
    }
  }


  get pageNumbers(): number[] {
    return Array(this.totalPages)
      .fill(0)
      .map((_, i) => i + 1);
  }


  downloadCSV(): void {
    const selectedFields = this.fields.filter((field) => field.selected);

    const headers = ['No.', ...selectedFields.map((field) => field.label)];
    const rows: (string | number)[][] = this.stockGeneralList.map((item: any, index: number) => {
      const row: (string | number)[] = [index + 1];
      selectedFields.forEach((field) => {
        row.push(this.resolveValue(item, field.key));
      });
      return row;
    });

    let csvContent = '';
    csvContent += headers.join(',') + '\r\n';
    rows.forEach((row) => {
      const escapedRow = row.map(
        (val: any) => `"${String(val ?? '').replace(/"/g, '""')}"`
      );
      csvContent += escapedRow.join(',') + '\r\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'product-list.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  /* ============================================================
   IMAGE PROXY HELPERS
============================================================ */

proxyImageUrl(url: string): string {

  if (!url) return url;

  // Already proxied?
  if (url.includes('/api/image-proxy/')) return url;

  const match = url.match(/\/storage\/(.+)$/);

  if (!match) return url;

  //  take backend base dynamically, used the environment.ts file here 
  const backendBase = environment.apiBaseUrl.replace(/\/api\/$/, '');

  return `${backendBase}/api/image-proxy/${match[1]}`;
}



/* ============================================================
   LOAD IMAGE AS BASE64
============================================================ */

async loadImageBase64(url: string): Promise<string | null> {
  try {

    const proxiedUrl = this.proxyImageUrl(url);

    console.log('Loading image:', proxiedUrl);

    const res = await fetch(proxiedUrl);

    if (!res.ok) {
      console.error(' HTTP error:', res.status);
      throw new Error(res.statusText);
    }

    const blob = await res.blob();

    return await new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });

  } catch (err) {
    console.error('Image load FAILED:', url, err);
    return null;
  }
}


/* ============================================================
   PRELOAD ALL PDF IMAGES
============================================================ */

async preparePdfImages(): Promise<void> {

  for (const row of this.paginatedStockList as any[]) {

    if (!row.product_image) continue;

    row.__img = await this.loadImageBase64(row.product_image);
  }
}




/* ============================================================
   MAIN PDF EXPORT
============================================================ */

async downloadPDF(): Promise<void> {

  //  Preload images first
  await this.preparePdfImages();

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a3',
  });

  const selectedFields = this.fields.filter(f => f.selected);

  if (!selectedFields.length) {
    Swal.fire('Error', 'Please select at least one column', 'error');
    return;
  }

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();


  /* ================= HEADER ================= */

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text('General Product List', pageWidth / 2, 16, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    pageWidth - 15,
    10,
    { align: 'right' }
  );


  /* ================= TABLE ================= */

  const headers = [
    { header: 'No.', dataKey: 'no' },
    ...selectedFields.map(f => ({
      header: f.label,
      dataKey: f.key,
    })),
  ];

  const dataToExport = this.paginatedStockList;

const body = dataToExport.map((item, index) => {

  const row: any = { no: index + 1 };

  selectedFields.forEach(f => {

    if (f.key === 'product_image') {
      row[f.key] = '';
      row.__img = item.__img;
    } else {
      row[f.key] = this.resolveValue(item, f.key);
    }

  });

  return row;
});



  autoTable(doc, {

    columns: headers,
    body,

    startY: 24,
    margin: { left: 10, right: 10 },

    theme: 'grid',
    tableWidth: 'auto',

    rowPageBreak: 'auto',

    /* ---------- GLOBAL STYLES ---------- */

   styles: {
  fontSize: 8,
  cellPadding: 2,
  overflow: 'linebreak',
  valign: 'middle',
},



    headStyles: {
      fillColor: [193, 151, 37],
      textColor: 255,
      halign: 'center',
      fontSize: 9,
      fontStyle: 'bold',
    },

    columnStyles: {
      no: { halign: 'center', cellWidth: 18 },
      product_image: { cellWidth: 38 },
    },


    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },


    /* ---------- IMAGE DRAWING ---------- */
    didParseCell: data => {

  // Only body rows
  if (data.section !== 'body') return;

  // Only image column
  if (data.column.dataKey === 'product_image') {
    data.cell.styles.minCellHeight = 32;
    data.cell.styles.halign = 'center';
    data.cell.styles.valign = 'middle';
  }

},


    didDrawCell: data => {

      if (data.column.dataKey !== 'product_image') return;

      const rowData: any = data.row.raw;

      const img = rowData?.__img;

      console.log(
        'didDrawCell:',
        data.row.index,
        img ? 'HAS IMG' : 'NO IMG'
      );

      if (!img) return;

      try {

        const padding = 3;

        const imgW = 28;
        const imgH = 28;

        const x =
          data.cell.x + (data.cell.width - imgW) / 2;

        const y =
          data.cell.y + (data.cell.height - imgH) / 2;

        doc.addImage(
          img,
          'JPEG',
          x,
          y,
          imgW,
          imgH,
          undefined,
          'FAST'
        );

        console.log('Image drawn');

      } catch (err) {
        console.error(' addImage failed:', err);
      }
    },


    /* ---------- FOOTER ---------- */

    didDrawPage: () => {

      doc.setFontSize(8);

      doc.text(
        `Page ${(doc as any).getNumberOfPages()}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    },

  });

  doc.save('general-product-report.pdf');
}




 downloadExcel(): void {

  const selectedFields = this.fields.filter(f => f.selected);

  if (!selectedFields.length) {
    Swal.fire('Error', 'Please select at least one column', 'error');
    return;
  }

  /* =============================
     CREATE HEADER ROW MANUALLY
  ============================== */

  const headers = ['No.', ...selectedFields.map(f => f.label)];

  /* =============================
     CREATE DATA ROWS (IF ANY)
  ============================== */

  const rows = this.paginatedStockList.map((item, index) => {

    const row: any = { 'No.': index + 1 };

    selectedFields.forEach(field => {
      row[field.label] = this.resolveValue(item, field.key) ?? '';
    });

    return row;
  });

  /* =============================
     HANDLE EMPTY DATA CASE
  ============================== */

  let worksheet: XLSX.WorkSheet;

  if (rows.length === 0) {

    // 👇 Create empty sheet with only headers
    worksheet = XLSX.utils.aoa_to_sheet([headers]);

  } else {

    worksheet = XLSX.utils.json_to_sheet(rows);

  }

  /* =============================
     CREATE WORKBOOK
  ============================== */

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  saveAs(blob, 'product-list.xlsx');
}


  downloadJSONRow(item: any) {
    const jsonString = JSON.stringify(item, null, 2); // Pretty-print JSON

    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `product-${item.id || 'data'}.json`;
    a.click();

    window.URL.revokeObjectURL(url);
  }


  downloadJSONAll(): void {
    const selectedFields = this.fields
      .filter((f) => f.selected)
      .map((f) => f.key);

    const filteredData = this.paginatedStockList.map((item) => {
      const filteredItem: any = {};
      selectedFields.forEach((field) => {
        filteredItem[field] = this.resolveValue(item, field);
      });
      return filteredItem;
    });

    const jsonString = JSON.stringify(filteredData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'general-list.json';
    a.click();

    window.URL.revokeObjectURL(url);
  }

  fields = [
     { key: 'product_image', label: 'Product Image', isImage: true, selected: true },
    { key: 'model_number', label: 'Model Number', selected: true },
    { key: 'unique_code_sku', label: 'Product SKU', selected: true },
    { key: 'type', label: 'Type', selected: true },
    { key: 'category.name', label: 'Category', selected: true },
    { key: 'sub_category_id', label: 'Sub Category', selected: true },
    { key: 'brand_name', label: 'Brand Name', selected: true },
    { key: 'supplier_code', label: 'Supplier Code', selected: true },
    { key: 'group', label: 'Group', selected: true },
    { key: 'product_name', label: 'Product Name', selected: true },
    { key: 'hsn_code', label: 'HSN Code', selected: true },
    { key: 'metal_type', label: 'Metal Type', selected: true },
    { key: 'purity', label: 'Purity', selected: true },
    { key: 'stamp', label: 'Stamp', selected: false },
    { key: 'unit', label: 'Unit', selected: false },
    { key: 'subunit', label: 'Subunit', selected: false },
    { key: 'conversion', label: 'Conversion', selected: false },
    { key: 'size', label: 'Size', selected: false },
    { key: 'gender', label: 'Gender', selected: false },
    { key: 'labour_charges', label: 'Labour Charges', selected: false },
    { key: 'making_charges', label: 'Making Charges', selected: false },
    { key: 'making_charges_unit', label: 'Making Charges Unit', selected: false },
    { key: 'thread_weight', label: 'Thread Weight', selected: false },
    { key: 'total_thread_price', label: 'Total Thread Price', selected: false },
    { key: 'actual_weight', label: 'Actual Weight', selected: false },
    { key: 'min_weight', label: 'Min Weight', selected: false },
    { key: 'max_weight', label: 'Max Weight', selected: false },
    { key: 'min_size', label: 'Min Size', selected: false },
    { key: 'max_size', label: 'Max Size', selected: false },
    { key: 'sell_dis_code', label: 'Sell Discount Code', selected: false },
    { key: 'min_disc', label: 'Min Discount', selected: false },
    { key: 'max_disc', label: 'Max Discount', selected: false },
    { key: 'disc_type', label: 'Discount Type', selected: false },
    { key: 'color', label: 'Color', selected: false },
    { key: 'clarity', label: 'Clarity', selected: false },
    { key: 'height', label: 'Height', selected: false },
    { key: 'length', label: 'Length', selected: false },
    { key: 'width', label: 'Width', selected: false },
    { key: 'description', label: 'Description', selected: false },
    
  ];

  applyColumnSelection() {
    localStorage.setItem('generallist', JSON.stringify(this.fields));
    this.showDropdown = false;
  }


  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }


  selectDropdown() {
    this.showselectDropdown = !this.showselectDropdown;
  }


  selectAllFields() {
    this.fields.forEach((field) => (field.selected = true));
  }


  deselectAllFields() {
    this.fields.forEach((field) => (field.selected = false));
  }

  get selectedFields() {
    return this.fields.filter((field) => field.selected);
  }


  restoreColumnSelection(): void {
    localStorage.removeItem('generallist');
    this.fields = [
      { key: 'product_image', label: 'Product Image', isImage: true, selected: true },
      { key: 'model_number', label: 'Model Number', selected: true },
      { key: 'unique_code_sku', label: 'Product SKU', selected: true },
      { key: 'type', label: 'Type', selected: true },
      { key: 'category.name', label: 'Category', selected: true },
      { key: 'sub_category_id', label: 'Sub Category', selected: true },
      { key: 'brand_name', label: 'Brand Name', selected: true },
      { key: 'supplier_code', label: 'Supplier Code', selected: true },
      { key: 'group', label: 'Group', selected: true },
      { key: 'product_name', label: 'Product Name', selected: true },
      { key: 'hsn_code', label: 'HSN Code', selected: true },
      { key: 'metal_type', label: 'Metal Type', selected: true },
      { key: 'purity', label: 'Purity', selected: true },
      { key: 'stamp', label: 'Stamp', selected: false },
      { key: 'unit', label: 'Unit', selected: false },
      { key: 'subunit', label: 'Subunit', selected: false },
      { key: 'conversion', label: 'Conversion', selected: false },
      { key: 'size', label: 'Size', selected: false },
      { key: 'gender', label: 'Gender', selected: false },
      { key: 'labour_charges', label: 'Labour Charges', selected: false },
      { key: 'making_charges', label: 'Making Charges', selected: false },
      { key: 'making_charges_unit', label: 'Making Charges Unit', selected: false },
      { key: 'thread_weight', label: 'Thread Weight', selected: false },
      { key: 'total_thread_price', label: 'Total Thread Price', selected: false },
      { key: 'actual_weight', label: 'Actual Weight', selected: false },
      { key: 'min_weight', label: 'Min Weight', selected: false },
      { key: 'max_weight', label: 'Max Weight', selected: false },
      { key: 'min_size', label: 'Min Size', selected: false },
      { key: 'max_size', label: 'Max Size', selected: false },
      { key: 'sell_dis_code', label: 'Sell Discount Code', selected: false },
      { key: 'min_disc', label: 'Min Discount', selected: false },
      { key: 'max_disc', label: 'Max Discount', selected: false },
      { key: 'disc_type', label: 'Discount Type', selected: false },
      { key: 'color', label: 'Color', selected: false },
      { key: 'clarity', label: 'Clarity', selected: false },
      { key: 'height', label: 'Height', selected: false },
      { key: 'length', label: 'Length', selected: false },
      { key: 'width', label: 'Width', selected: false },
      { key: 'description', label: 'Description', selected: false },
      
    ];
  }


  getAllGeneral() {
    let params = new HttpParams().set('firm_id', this.currentFirmId);
    this.stockGeneralService.getProducts(params).subscribe((response: any) => {
      this.generalData = response.data;
    });
  }


 async printTable() {

  await this.preparePdfImages();

 const data = this.paginatedStockList;

  let printContent = `
  <html>
  <head>
    <title>Stock General List</title>

    <style>

      body {
        font-family: Arial, sans-serif;
        margin: 0;
      }

      h3 {
        text-align: center;
        margin-bottom: 10px;
      }

      /* =============================
         MAIN TABLE GRID
      ============================== */

      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 11px;
      }

      th, td {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
        padding: 6px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
      }

      th:first-child,
      td:first-child {
        border-left: 2px solid #000;
      }

      thead th {
        border-top: 2px solid #000;
        background: #f2f2f2;
        font-weight: 600;
      }

      tbody tr:last-child td {
        border-bottom: 2px solid #000;
      }

      img {
        max-width: 70px;
        max-height: 70px;
        object-fit: contain;
      }

      /* =============================
         PRINT RULES
      ============================== */

      @media print {

        @page {
          size: auto;
          margin: 8mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        thead {
          display: table-header-group;
        }

        tr {
          page-break-inside: avoid;
        }

      }

    </style>

  </head>
  <body>

    <h3>Stock General List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

  // ===== HEADERS =====
  this.selectedFields.forEach(field => {
    if (field.selected) {
      printContent += `<th>${field.label}</th>`;
    }
  });

  printContent += `
        </tr>
      </thead>
      <tbody>
  `;

  // ===== ROWS =====
  data.forEach((item, index) => {

    printContent += `
      <tr>
        <td>${index + 1}</td>
    `;

    this.selectedFields.forEach(field => {

      if (!field.selected) return;

      let value = item[field.key];
      let displayValue = '';

      // ===== IMAGE =====
      if (field.isImage && item.__img) {
        displayValue = `<img src="${item.__img}" />`;
      }

      // ===== OBJECT SAFE =====
      else if (value && typeof value === 'object') {
        displayValue =
          value.name ||
          value.title ||
          value.label ||
          '';
      }

      // ===== NORMAL =====
      else {
        displayValue = value ?? '';
      }

      printContent += `<td>${displayValue}</td>`;

    });

    printContent += `</tr>`;
  });

  printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

  const printWindow = window.open('', '_blank');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  }
}





  sortBy(field: string) {
    if (this.sortKey === field) {

      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = field;
      this.sortDirection = 'asc';
    }

    this.stockGeneralList.sort((a, b) => {
      // CHANGE THESE TWO LINES:
      const aVal = this.resolveValue(a, field);
      const bVal = this.resolveValue(b, field);

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      const aStr = String(aVal).toLowerCase();
      const bStr = String(bVal).toLowerCase();

      if (aStr < bStr) return this.sortDirection === 'asc' ? -1 : 1;
      if (aStr > bStr) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.updatePaginatedList();
  }

  openProductDetails(id: number): void {
    //for packaging
    this.packagingService.getPackagingListByProductId(id).subscribe((packagingResponse: any) => {
      const packagingList = packagingResponse?.data?.filter((p: any) => p.product_id === id) || [];

      //for metal
      this.MetalService.getMetalsByProductId(id).subscribe((metalResponse: any) => {
        const metalDataList = metalResponse?.data?.filter((m: any) => m.product_id === id) || [];

        //for stone
        this.productservice.getStonesByProductId(id).subscribe((stoneResponse: any) => {
          const stoneDataList = stoneResponse?.data?.filter((s: any) => s.product_id === id) || [];

          //for general details
          this.stockGeneralService.getProductById(id).subscribe((response: any) => {
            const product = response?.data || null;
            const allFields = this.fields;

            const generalHtml = product
              ? allFields.map(field => {
                const value = this.resolveValue(product, field.key);
                return `<p><strong style="color: #c19725;">${field.label}:</strong> ${value}</p>`;
              }).join('')
              : `<p>No data found</p>`;

            const packagingHtml = packagingList.length > 0
              ? packagingList.map((p: { product_code: any; material_name: any; material_categories: any; size: any; quantity: any; per_piece: any; total_price: any; supplier_code: any; }, i: number) => `
                <div style="margin-bottom: 10px; border: 1px solid #ccc; padding: 10px; border-radius: 6px;">
                  <h4 style="color: #c19725; margin-bottom: 8px;">Packaging #${i + 1}</h4>
                  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                    <p><strong style="color: #c19725;">Product Code:</strong> ${p.product_code}</p>
                    <p><strong style="color: #c19725;">Material Name:</strong> ${p.material_name}</p>
                    <p><strong style="color: #c19725;">Category:</strong> ${p.material_categories}</p>
                    <p><strong style="color: #c19725;">Size:</strong> ${p.size}</p>
                    <p><strong style="color: #c19725;">Quantity:</strong> ${p.quantity}</p>
                    <p><strong style="color: #c19725;">Per Piece:</strong> ₹${p.per_piece}</p>
                    <p><strong style="color: #c19725;">Total Price:</strong> ₹${p.total_price}</p>
                    <p><strong style="color: #c19725;">Supplier Code:</strong> ${p.supplier_code}</p>
                  </div>
                </div>
              `).join('')
              : `<p>No packaging data found</p>`;

            const metalHtml = metalDataList.length > 0
              ? metalDataList.map((m: { artical_name: any; metal_type: any; unit: any; code: any; quantity: any; per_piece_weight: any; total_weight: any; per_piece_price: any; total_price: any; supplier_code: any; }, i: number) => `
                <div style="margin-bottom: 10px; border: 1px solid #ccc; padding: 10px; border-radius: 6px;">
                  <h4 style="color: #c19725; margin-bottom: 8px;">Metal #${i + 1}</h4>
                  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                    <p><strong style="color: #c19725;">Article Name:</strong> ${m.artical_name}</p>
                    <p><strong style="color: #c19725;">Metal Type:</strong> ${m.metal_type}</p>
                    <p><strong style="color: #c19725;">Unit:</strong> ${m.unit}</p>
                    <p><strong style="color: #c19725;">Code:</strong> ${m.code}</p>
                    <p><strong style="color: #c19725;">Quantity:</strong> ${m.quantity}</p>
                    <p><strong style="color: #c19725;">Per Piece Weight:</strong> ${m.per_piece_weight}</p>
                    <p><strong style="color: #c19725;">Total Weight:</strong> ${m.total_weight}</p>
                    <p><strong style="color: #c19725;">Per Piece Price:</strong> ₹${m.per_piece_price}</p>
                    <p><strong style="color: #c19725;">Total Price:</strong> ₹${m.total_price}</p>
                    <p><strong style="color: #c19725;">Supplier Code:</strong> ${m.supplier_code}</p>
                  </div>
                </div>
              `).join('')
              : `<p>No metal data found</p>`;

            const stoneHtml = stoneDataList.length > 0
              ? stoneDataList.map((s: { stone_name: any; categories: any; code: any; unit: any; quantity: any; per_piece_weight: any; total_weight: any; per_piece_price: any; total_price: any; supplier_code: any; }, i: number) => `
                <div style="margin-bottom: 10px; border: 1px solid #ccc; padding: 10px; border-radius: 6px;">
                  <h4 style="color: #c19725; margin-bottom: 8px;">Stone #${i + 1}</h4>
                  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                    <p><strong style="color: #c19725;">Stone Name:</strong> ${s.stone_name}</p>
                    <p><strong style="color: #c19725;">Category:</strong> ${s.categories}</p>
                    <p><strong style="color: #c19725;">Code:</strong> ${s.code}</p>
                    <p><strong style="color: #c19725;">Unit:</strong> ${s.unit}</p>
                    <p><strong style="color: #c19725;">Quantity:</strong> ${s.quantity}</p>
                    <p><strong style="color: #c19725;">Per Piece Weight:</strong> ${s.per_piece_weight}</p>
                    <p><strong style="color: #c19725;">Total Weight:</strong> ${s.total_weight}</p>
                    <p><strong style="color: #c19725;">Per Piece Price:</strong> ₹${s.per_piece_price}</p>
                    <p><strong style="color: #c19725;">Total Price:</strong> ₹${s.total_price}</p>
                    <p><strong style="color: #c19725;">Supplier Code:</strong> ${s.supplier_code}</p>
                  </div>
                </div>
              `).join('')
              : `<p>No stone data found</p>`;

            Swal.fire({
              title: `<strong style="font-size: 20px; color: #c19725;">Product Details</strong>`,
              html: `
                  <div style="font-size: 14px; height: 600px; overflow-y: auto; font-family: 'Segoe UI', sans-serif;">
                    <!-- Tabs Header -->
                    <ul class="nav nav-tabs" style="display: flex; border-bottom: 1px solid #ccc; padding: 0; margin-bottom: 15px;">
                      <li style="flex: 1;"><a class="tab-link active" href="#general-tab" style="display: block; padding: 10px; text-align: center; background: #fdf5e4; color: #c19725; text-decoration: none;">General</a></li>
                      <li style="flex: 1;"><a class="tab-link" href="#packaging-tab" style="display: block; padding: 10px; text-align: center; background: #e6f4ff; color: #1976d2; text-decoration: none;">Packaging</a></li>
                      <li style="flex: 1;"><a class="tab-link" href="#metal-tab" style="display: block; padding: 10px; text-align: center; background: #fce4ec; color: #8e24aa; text-decoration: none;">Metal</a></li>
                      <li style="flex: 1;"><a class="tab-link" href="#stone-tab" style="display: block; padding: 10px; text-align: center; background: #f3e5f5; color: #2e7d32; text-decoration: none;">Stone</a></li>
                    </ul>

                    <!-- Tabs Content -->
                    <div id="general-tab" class="tab-content active">
                      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">${generalHtml}</div>
                    </div>
                    <div id="packaging-tab" class="tab-content" style="display: none;">
                      <div>${packagingHtml}</div>
                    </div>
                    <div id="metal-tab" class="tab-content" style="display: none;">
                      <div>${metalHtml}</div>
                    </div>
                    <div id="stone-tab" class="tab-content" style="display: none;">
                      <div>${stoneHtml}</div>
                    </div>
                  </div>
                `,
              showCloseButton: true,
              focusConfirm: false,
              confirmButtonText: '<span style="color: white;">Close</span>',
              width: '900px',
              scrollbarPadding: false,
              customClass: {
                popup: 'product-details-popup',
                confirmButton: 'product-confirm-button'
              },
              didOpen: () => {
                // Tab switching logic
                const tabLinks = document.querySelectorAll('.tab-link');
                const tabContents = document.querySelectorAll('.tab-content');

                tabLinks.forEach((tab, index) => {
                  tab.addEventListener('click', (e) => {
                    e.preventDefault();

                    tabLinks.forEach(t => t.classList.remove('active'));
                    tabContents.forEach(c => (c as HTMLElement).style.display = 'none');

                    tab.classList.add('active');
                    (tabContents[index] as HTMLElement).style.display = 'block';
                  });
                });

                // Remove focus from confirm button
                (document.activeElement as HTMLElement)?.blur();
              }
            });
          });
        });
      });
    });
  }

public resolveValue(obj: any, key: string): any {
  if (!obj) return null;

  /* 🔹 IMAGE FIELDS — RETURN RAW */
  if (
    key === 'product_image' ||
    key === 'product_image_2' ||
    key === 'product_image_3'
  ) {
    return obj[key] || null;
  }

  /* 🔹 BRAND NAME FIX */
  if (key === 'brand_name') {
    const brandId = obj.brand_name;
    return this.brandMap[brandId] ?? brandId ?? '-';
  }

  /* 🔹 Category */
  if (key === 'category.name' && obj.category?.name) {
    return obj.category.name;
  }

  /* 🔹 Sub Category */
  if (key === 'sub_category_id' && obj.sub_category_id) {
    const subCategory = this.generalData.find(
      (data: any) => data.id === obj.sub_category_id
    );
    return subCategory?.name ?? obj.sub_category_id;
  }

  /* 🔹 Generic resolver */
  try {
    const value = key.split('.').reduce((o, k) => (o ? o[k] : null), obj);

    return value !== null && value !== undefined && value !== ''
      ? value
      : null;   // ⬅️ IMPORTANT: null not "-"
  } catch {
    return null;
  }
}

}
